export class UrlUtil {
  static getQueryParameterByName(name, url) {
    if (!url) url = window.location.href;

    try {
      const parsedUrl = new URL(url);
      return parsedUrl.searchParams.get(name) || null;
    } catch (error) {
      console.error('Invalid URL provided:', error);
      return null;
    }
  }
}
